import React, { Component } from 'react';
import './index.css';

/*
=================================
Thumbnail Component Documentation
=================================
Introduction:
---------------------------------
Add a thumbnail like so:
        <Thumbnail
          state={this.state}
          title="HOME PAGE"
          width={210}
          height={118}
          titlePosition="below"
            />
At a minumim, provide the state, title, width, height and titlePoition
props as shown.

See thumbnail.css for default css values
---------------------------------
Description of props:
---------------------------------
state (required):
      Allows the video title and image to be updated dynamically.
title (required):
      Text to be displayed above the thumbnail. Not the video title.
width (required):
      The desired thumbnail width in pixels
height (required):
      The desired thumbnail height in pixels
titlePosition (required):
      Where to put the dynamic video title. Possible options:
      - below
      - beside
      - none

lineHeight:
      How tall the title should be in rems
      Defaults to 1.6rem
titleNumLines:
      How many lines of text in the title.
      Default depends on titlePosition. See thumbnail.css
titleLineLength:
      How long the title should be in pixels
styles:
      Custom styles to be applied to the thumbnail.
      Can be used to override default values and to impement weird one-off
      styles - like the apple TV thumbnails.
      See
---------------------------------
Example with more settings and custom styles:
---------------------------------
<Thumbnail
  state={this.state}
  title="Apple TV SEARCH RESULTS"
  width={239}
  height={135}
  titlePosition="beside"
  overlay="none"
  titleLineLength={800}
  titleNumLines={1}
  lineHeight={4.5}
  styles={{
    'fontSize':'3.5em',
    'fontWeight':'200',
    'marginTop':'2.8rem'
  }}
  />
*/

class Thumbnail extends Component {
  constructor(props){
    super(props);
    let inlineStyles = {};
    let avatarInlineStyles = {};

    //handle settings from props
    if(this.props.titlePosition === "below"){
      this.groupClass = "groupBelow";
      this.titleClass = "title below";
      inlineStyles['width']=this.props.width+"px";
    }else if(this.props.titlePosition === "beside"){
      this.groupClass = "groupBeside";
      this.titlePosition = "fullwidth";
      this.titleClass = "title beside";
    }else if(this.props.titlePosition === "none"){
      this.groupClass = "groupBelow hideTitle";
      this.titleClass = "title hidden";
    }
    //style overrides
    let lineHeight = 1.6;

    if(this.props.lineHeight){
      lineHeight = this.props.lineHeight;
      inlineStyles['lineHeight']=lineHeight+"rem";
      //inlineStyles['maxHeight']=lineHeight+"rem";
    }
    //if(this.props.titleNumLines){
    //  let rems = lineHeight*this.props.titleNumLines;
    //  inlineStyles['maxHeight']=rems+"rem";
    //}
    /*if(this.props.titleNumLines === 2){
      this.lineClass = "clampLines";
    } else {
      this.lineClass = "singleLine";
    }*/
    if(this.props.titleLineLength){
      inlineStyles['maxWidth']=this.props.titleLineLength+"px";
      inlineStyles['minWidth']=this.props.titleLineLength+"px";
      const totalComponentWidth = this.props.titleLineLength+this.props.width;
      this.componentInlineStyle={'minWidth':totalComponentWidth+"px"}
    }
    if(this.props.titleSize){
      inlineStyles['fontSize']=this.props.titleSize+"px";
    }
    if(this.props.titleWeight){
      inlineStyles['fontWeight']=this.props.titleWeight;
    }
    if(this.props.titleHeight){
      inlineStyles['max-height']=this.props.titleHeight+"rem";
    }
    if(this.props.avatarHeight){
      avatarInlineStyles['width']=this.props.avatarHeight+"px";
      avatarInlineStyles['height']=this.props.avatarHeight+"px";
      avatarInlineStyles['marginRight']="12px";
    }
    if(this.props.state.title === ""){
      this.props.state.title = "Enter your title to see how it looks";
    }
    //allow a separate 'styles' prop for custom syles
    this.titleInlineStyle = Object.assign(inlineStyles, this.props.styles)
    this.avatarInlineStyle = Object.assign(avatarInlineStyles, this.props.styles)


  }
  render() {
    return(
      <div className={"thumbnailComponent"} style={this.componentInlineStyle}>
        <div className="componenTitle fullwidth">{this.props.title}</div>
        <div className={"thumbnailGroup " + this.groupClass}>
          <div className="thumbnailImageContainer">
            <img className="thumbnailImage"
                  width={this.props.width}
                  height={this.props.height}
                  src={this.props.state.imgSrc}
                  alt="thumbnail"/>
                  <div className="clearfix"></div>
              <Overlay type={this.props.overlay}/>
          </div>
          <div className={"avatar"}
              style={this.avatarInlineStyle}>
          </div>
          <div className={"thumbnailTitle"}>
            <div className={"title " + this.lineClass}
                style={this.titleInlineStyle}>
                {this.props.state.title}
            </div>
            <Details type={this.props.videoDetails} size={this.props.detailsSize} width={this.props.titleLineLength}/>
          </div>
        </div>
      </div>
    );
  }
}
export default Thumbnail;

//This controls the little time overlay on thumbnails.
function Overlay(props){
  if(props.type==="watchlater"){
    return (
      <div className="watch-later-overlay">
        <span>
          <img className="watchlater-icon" src="/open-iconic/svg/media-play.svg" alt="Play"/>
        </span>
        <span>PLAY ALL</span>
      </div>
    )
  }else if(props.type==="none"){
    return null;
  }else{
    return (
      <div className="time-overlay">14:56</div>
    )
  }
}

//This controls the channel details on thumbnails.
function Details(props){
  let detailsInlineStyles = {};
  if(props.size){
    detailsInlineStyles['fontSize']=props.size+"px";
  }
  if(props.width){
    //detailsInlineStyles['maxWidth']=props.width+"px";
  }
  let detailsInlineStyle = Object.assign(detailsInlineStyles, props.styles)
  if(props.type==="show"){
    return (
      <div className={"videoDetails"} style={detailsInlineStyle}>
        <div className={"channelName"}>
          Your Channel
        </div>
        <div className={"videoStats"}>
          123K views • 1 hour ago
        </div>
      </div>
    )
  }else if(props.type==="channel"){
    return (
      <div className={"videoDetails channel"} style={detailsInlineStyle}>
      <div className={"channelName"}>
        Your Channel
      </div>
      </div>
    )
  }else if(props.type==="stats"){
    return (
      <div className={"videoDetails stats"} style={detailsInlineStyle}>
        <div className={"videoStats"}>
          123K views • 1 hour ago
        </div>
      </div>
    )
  }else if(props.type==="description"){
    return (
      <div className={"videoDetails description"} style={detailsInlineStyle}>
        <div className={"videoStats"}>
          123K views • 1 hour ago
        </div>
        <div className={"videoDescription"}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </div>
      </div>
    )
  }else if(props.type==="combined"){
    return (
      <div className={"videoDetails combined"} style={detailsInlineStyle}>
        <div className={"videoStats"}>
          Your Channel • 123K views • 1 hour ago
        </div>
      </div>
    )
  }else if(props.type==="combinedDetails"){
    return (
      <div className={"videoDetails combined"} style={detailsInlineStyle}>
        <div className={"videoStats"}>
          Your Channel • 123K views
        </div>
        <div className={"videoDescription clampLines"} style={detailsInlineStyle}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </div>
      </div>
    )
  }else{
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Thumbnail/index.js